'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Popover, PopoverContent, PopoverTrigger } from '@workspace/ui/components/popover';
import { appTopHeaderActionSurfaceClassName } from './app-top-header';
import { cn } from '@workspace/ui/lib';
import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import Link from 'next/link';

export interface AppTopHeaderProfileMenuItem {
  label: string;
  icon: LucideIcon;
  href?: string;
  external?: boolean;
  onSelect?: () => void;
  content?: ReactNode;
}

interface AppTopHeaderProfileMenuProps {
  initials: string;
  items: AppTopHeaderProfileMenuItem[];
  className?: string;
}

export function AppTopHeaderProfileMenu({
  initials,
  items,
  className,
}: AppTopHeaderProfileMenuProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            appTopHeaderActionSurfaceClassName,
            'flex size-[30px] items-center justify-center rounded-full text-sm leading-5',
            className
          )}
          aria-label="Open profile menu"
        >
          <p>{initials}</p>
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="end"
        sideOffset={12}
        className="bg-grey-0 dark:bg-grey-1000 w-[250px] gap-6 rounded-4xl p-6"
      >
        <div className="flex flex-col gap-2">
          {items.map((item) => {
            if (item.content) {
              return <div key={item.label}>{item.content}</div>;
            }

            const Icon = item.icon;
            const content = (
              <>
                <Icon className="size-6 stroke-2!" />
                <p>{item.label}</p>
              </>
            );

            const className =
              'text-neutral-200 cursor-pointer font-medium dark:text-neutral-100 hover:bg-grey-50 dark:hover:bg-grey-900 flex h-12 w-full items-center gap-3 rounded-xl px-3 text-left text-sm';

            if (item.href) {
              return (
                <Link
                  key={item.label}
                  href={item.href!}
                  target={item.external ? '_blank' : undefined}
                  rel={item.external ? 'noreferrer' : undefined}
                  className={className}
                  onClick={item.onSelect}
                >
                  {content}
                </Link>
              );
            }

            return (
              <button key={item.label} type="button" className={className} onClick={item.onSelect}>
                {content}
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
